module.exports = __webpack_public_path__ + "static/media/USJETAA Logo.9970432e.jpeg";